module.exports = "pegasus/assets/theme6/main-bg.jpg";